import { Link } from './nav'
import { RefreshCw } from 'lucide-react'
import { taskDetailUrl } from '../lib/taskDetailPath'
import './RetriggerLinks.css'

export interface RetriggerEntry {
  id: string
  retrigger_id?: string
  original_id?: string
  created_at: string
  project_id?: string
  pass_type?: string
}

interface RetriggerLinksProps {
  entityType: 'test_run' | 'exploration'
  retriggeredFrom: RetriggerEntry | null
  retriggersFrom: RetriggerEntry[]
  currentProjectId: string
}

function buildEntityLink(entityType: string, entityId: string, projectId: string): string {
  switch (entityType) {
    case 'test_run':
      return taskDetailUrl(projectId, entityId)
    case 'exploration':
      return taskDetailUrl(projectId, entityId)
    default:
      return '#'
  }
}

function entityLabel(entityType: string): string {
  switch (entityType) {
    case 'test_run': return 'test run'
    case 'exploration': return 'exploration'
    default: return entityType.replace(/_/g, ' ')
  }
}

export default function RetriggerLinks({ entityType, retriggeredFrom, retriggersFrom, currentProjectId }: RetriggerLinksProps) {
  if (!retriggeredFrom && retriggersFrom.length === 0) return null

  return (
    <section className="retrigger-links" data-testid="retrigger-links">
      {retriggeredFrom && (
        <div className="retrigger-links__row" data-testid="retriggered-from">
          <RefreshCw size={13} aria-hidden="true" />
          <span className="retrigger-links__label">Retriggered from:</span>
          <Link
            to={buildEntityLink(entityType, retriggeredFrom.original_id!, retriggeredFrom.project_id ?? currentProjectId)}
            className="retrigger-links__link"
            data-analytics-event="retrigger-source-link"
          >
            Original {entityLabel(entityType)}
          </Link>
        </div>
      )}
      {retriggersFrom.length > 0 && (
        <div className="retrigger-links__row" data-testid="retriggers-list">
          <RefreshCw size={13} aria-hidden="true" />
          <span className="retrigger-links__label">Retriggers:</span>
          {retriggersFrom.map((r, i) => (
            <span key={r.id}>
              {i > 0 && <span className="retrigger-links__sep">,</span>}
              <Link
                to={buildEntityLink(entityType, r.retrigger_id!, r.project_id ?? currentProjectId)}
                className="retrigger-links__link"
                data-analytics-event="retrigger-target-link"
              >
                {new Date(r.created_at).toLocaleString()}
              </Link>
            </span>
          ))}
        </div>
      )}
    </section>
  )
}
